(function (skyward, $, History, undefined)
{
    skyward.breadcrumb = skyward.breadcrumb || {};
    var crumbLayer;
    var breadcrumbs;
    var init = function (selector)
    {
        breadcrumbs = $(selector).find("#breadcrumbs");
        if (breadcrumbs.length)
        {
            $.ajax(skyward.global.virtualDir + "Security/Window/UpdateRelatedRecord",
            {
                type: "POST",
                dataType: "JSON",
                activityIndicator: { hideGlass: true },
                data: { breadcrumb: JSON.stringify(buildCrumb()) }
            });
            skyward.window.registerLayoutResizeCallback(function ()
            {
                truncate(breadcrumbs);
            });

            truncate(breadcrumbs);
        }
    };

    var buildCrumb = function ()
    {
        var crumb = {};
        crumb.id = "breadcrumb";
        crumb.items = [];
        var crumbItemObject = {};
        crumbItemObject.key = "DisplayName";
        var displayText = skyward.extensions.encodeHtml($("#friendlyNameContents").text());
        var displayName = displayText.indexOf(":") >= 0 ? displayText.split(" : ")[1] : displayText;
        crumbItemObject.value = displayName !== "" ? displayName : "Home";
        crumb.items.push(crumbItemObject);
        return crumb;
    };

    var truncate = function (breadcrumbs)
    {
        var historyIsShowing = (crumbLayer && !crumbLayer.closing) ? true : false;
        if (historyIsShowing)
        {
            hideHistoryCrumbs();
        }

        breadcrumbs.find(".overflowCrumb").removeClass("overflowCrumb");
        var maxCrumbWidth = skyward.window.clientWidth * .75;

        var breadcrumbsWidth = 0;
        breadcrumbs.find("li").each(function ()
        {
            breadcrumbsWidth += $(this).width();
        });

        var ellipsis = $("#ellipsis, #ellipsis + li.breadcrumbSeparator");
        var widthToHide = breadcrumbsWidth - maxCrumbWidth + ellipsis.width();

        if (widthToHide > 0)
        {

            var showEllipsis = false;
            breadcrumbs.find("li:not(.doNotTruncate)").each(function ()
            {
                var jQThis = $(this);
                var separator = jQThis.next('.breadcrumbSeparator');
                widthToHide -= jQThis.width();
                jQThis.addClass("overflowCrumb");
                separator.addClass("overflowCrumb");
                showEllipsis = true;
                return (widthToHide >= 0);
            });

            if (showEllipsis)
            {
                ellipsis.addClass("overflowCrumb");
            }
        }

        if (historyIsShowing)
        {
            skyward.breadcrumb.displayBreadcrumbHistory();
        }
    };

    skyward.breadcrumb.displayBreadcrumbHistory = function ()
    {
        var menuItems = [];
        menuItems.push(
        {
            type: 'title',
            text: 'History'
        });

        breadcrumbs.find(".crumb").each(function ()
        {
            var crumb = $(this);

            var menuItem =
            {
                type: 'item',
                text: crumb.text(),
                click: crumb.attr("onclick")
            };
            menuItems.push(menuItem);
        });
        crumbLayer = skyward.modalLayer.showMenu(menuItems, $("#ellipsis"), { afterClose: hideHistoryCrumbs });
    };

    var hideHistoryCrumbs = function ()
    {
        if (crumbLayer)
        {
            crumbLayer.close();
            crumbLayer = null;
        }
    };

    var navigateViaBreadcrumbs = function (postData, url)
    {
        $.ajax(skyward.global.virtualDir + "Security/Window/NavigateViaBreadcrumbs",
            {
                type: "POST",
                dataType: "JSON",
                async: false,
                data: postData,
                success: function (data)
                {
                    if (data.success && typeof(url) === "string")
                    {
                        window.location.href = url;
                    }
                }
            });
    }

    skyward.breadcrumb.breadcrumbClicked = function (index, url)
    {
        $(this).addClass("breadcrumbClicked");
        var data = { index: index };
        navigateViaBreadcrumbs(data, url);
    };

    /**
     * Sync breadcrumb trail with the screen we landed on after delete. 
     * @param {any} urlReferrer -the url of the breadcrumb we want to be in sync with
     */
    skyward.breadcrumb.removeStaledBreadcrumbs = function (urlReferrer)
    {
        var index;
        breadcrumbs.find(".crumb").each(function ()
        {
            var element = $(this);
            if (element.data("url") === urlReferrer)
            {
                index = element.data("index");
                return;
            }
        });

        var data = { index: index };
        // This is a work-around to remove staled crumbs from breadcrumb trail (until breadcrumbs are nicer to work with)
        navigateViaBreadcrumbs(data);
    }

    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery, window.History));